import baseClient from './apiClient';
import { InternalAxiosRequestConfig, AxiosResponse } from 'axios';
import tokenService from '@/services/token.service';
import { handleErrorResponse } from './helper';
import router from '@/router';
import { useSessionStore } from '@/stores/session.store';

const interceptorConfig = baseClient.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    const sessionStore = useSessionStore();
    config.headers.Authorization = `Bearer ${tokenService.getToken()}`;
    if (!router.currentRoute.value.meta?.isAdmin && sessionStore.currentOrganisationId) {
      const hasAccess = sessionStore.organisations?.some((org) => org.id === sessionStore.currentOrganisationId);
      if (hasAccess) {
        config.headers['Current-Organisation'] = sessionStore.currentOrganisationId;
      } else {
        sessionStore.setCurrentOrganisationId(null);
      }
    }
    return config;
  },
  (error: any) => Promise.reject(error)
);

const interceptorErrors = baseClient.interceptors.response.use(
  (response: AxiosResponse) => response.data,
  (error: any) => {
    handleErrorResponse(error);

    // Generic redirect for domain-admin feature-flagged routes when backend denies access (e.g., domain-feature middleware returns 403)
    try {
      const status = error?.response?.status;
      const current = router.currentRoute.value;
      if (
        status === 403 &&
        current?.meta?.feature &&
        current?.meta?.isAdmin &&
        current?.params?.organisationId
      ) {
        const organisationId = String(current.params.organisationId);
        router.replace(`/admin/organisations/${organisationId}/details`);
      }
    } catch (_) {
      // No-op: fallback to original error handling
    }
    return Promise.reject(error);
  }
);

export default { interceptorConfig, interceptorErrors };
